export const normalizeCourseName = (value) => (value || "").toString().trim().toLowerCase();

export const toDateValue = (value) => {
  if (!value) return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  if (typeof value?.toDate === "function") {
    return value.toDate();
  }
  if (typeof value?.seconds === "number") {
    return new Date(value.seconds * 1000);
  }
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const addDays = (date, days) => {
  const nextDate = new Date(date);
  nextDate.setDate(nextDate.getDate() + days);
  return nextDate;
};

export const buildCourseKey = (name, intakeId, rawIntakeDate) => {
  if (!name) return "";
  if (intakeId) return `${name}__${intakeId}`;
  if (rawIntakeDate) return `${name}__${rawIntakeDate}`;
  return name;
};

export const buildInvoicesForCourse = (courseData, totalPaid, options = {}) => {
  const feeDeposit = Number(courseData?.feeDeposit || 0);
  const feeInstallments = Number(courseData?.feeInstallments || 0);
  const duration = Number(courseData?.mcourseDuration || 0);
  if (!duration || (!feeDeposit && !feeInstallments)) {
    return [];
  }

  const admissionDate = toDateValue(options.admissionDate);
  const normalizedStatus = (options.courseStatus || "").toString().trim().toLowerCase();
  const isAdmitted = normalizedStatus === "active" || normalizedStatus === "student" || (!!admissionDate && normalizedStatus !== "pending");
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const invoicesData = [];
  let carryOver = Math.max(0, totalPaid || 0);

  for (let month = 1; month <= duration; month++) {
    const expectedAmount = month === 1 ? feeDeposit : feeInstallments;
    const paidForMonth = Math.min(expectedAmount, carryOver);
    const dueDate = admissionDate ? addDays(admissionDate, (month - 1) * 30) : null;
    const dueTodayOrEarlier = dueDate ? dueDate <= today : false;

    let status = "Pending";
    if (paidForMonth >= expectedAmount) {
      status = "Paid";
    } else if (paidForMonth > 0) {
      status = "Partially Paid";
    } else if (!isAdmitted || !dueDate) {
      status = "Pending";
    } else if (dueTodayOrEarlier) {
      status = "Due";
    } else {
      status = "Upcoming";
    }

    invoicesData.push({
      month: `Month ${month}`,
      expectedAmount,
      paidAmount: paidForMonth,
      balance: Math.max(0, expectedAmount - paidForMonth),
      dueDate,
      status,
    });
    carryOver -= paidForMonth;
  }

  return invoicesData;
};
